<template>
  <section class="section section_bg container-fluid mobile_div    first_page  ">
  <div class="col-12 second_section" v-if="is_not_have_access==true">
    <p>Увы , но у вас нет доступа к этой категории блога. Обратитесь к администратору сайта.</p>
  </div>

    <loading-block v-if="is_not_have_access==false &&  is_load==false" :loading="!is_load"/>

  <div class="row d-flex justify-content-center pb-100" v-if="is_load">


    <div class="container   ">

        <div class="section_header no_margin mobile_div container back_div_element mb-2 mt-2">
          <router-link tag="a" class="btn" :to="{name: 'posts'}"  ><i class="fa fa-backward"></i> Назад</router-link>

        </div>

      <div>
        <CategoryCard v-if="is_load" :category="category"/>
      </div>


      <div class="section_black second_section" >
        <div class="row mt-2 mb-2 d-flex justify-content-center">
          <div class="col">
            <input type="text" v-model="search_string" class="form-control" placeholder="Поиск"/>
          </div>
          <div class="col-2 col-md-2">
            <button class="btn btn-second" @click="startSearch()"><i class="fa fa-search"></i></button>
          </div>
        </div>
        <ul class="nav justify-content-center widget_nav">
          <li class="nav-item" >
            <a href="javascript:void(0)" @click="changeOrderBy('popular')" class="nav-link" :class="{'active':orderby=='popular',' ':!(orderby=='popular')}">Популярное</a>


          </li>
          <li class="nav-item" >
            <a href="javascript:void(0)" @click="changeOrderBy('last')" class="nav-link" :class="{'active':orderby=='last',' ':!(orderby=='last')}">Новое</a>
          </li>
          <li class="nav-item" >
            <a href="javascript:void(0)" @click="changeOrderBy('comments')" class="nav-link" :class="{'active':orderby=='comments',' ':!(orderby=='comments')}">Обсуждаемое</a>

          </li>
        </ul>
      </div>


        <!-- shape Hero -->

        <!-- 1st Hero Variation -->
        <div v-if="category.last_id && category_access.write==1" class="second_section d-flex justify-content-center" >

          <router-link tag="a" class="btn" :to="{name: 'add_post',query:{'category_id':category.last_id}}">
            Новая запись
          </router-link>


        </div>





        <div v-if="pinned.length>0"   v-for="(post,post_index) in pinned"
             :key="post_index">
          <div class="blog_post_row post_material_mini block_row"
          >
          <i class="ni ni-notification-70"></i>




          <div class="post_material_mini_content" @click="openPost(post.last_id,post.category_post.alias)">
            <editorjsrender  :blocks_json="post.short.blocks"></editorjsrender>
          </div>
          <div class="d-flex justify-content-between post_material_mini_bottom">
            <p><i class="fa fa-calendar-o"></i><small>&nbsp; {{ post.created_at }}</small></p>
            <p><router-link :to="{name: 'post', params: { id: post.last_id,'alias':post.category_post.alias }}"><i class="fa fa-comment-0"></i>  ({{ post.total_comments_count }})</router-link></p>
          </div>


          <router-link class="btn  " v-if="post.short.blocks.length!=post.content.blocks.length" :to="{name: 'post', params: { id: post.last_id,'alias':post.category_post.alias }}"
          >
            Читать далее
          </router-link>
          </div>
        </div>








            <div   style="padding:0px;"
                 v-for="post in posts"
                 :key="post.last_id">
              <div class="blog_post_row post_material_mini block_row"
                   >




                <div class="post_material_mini_content" @click="openPost(post.last_id,post.category_post.alias)">
                  <editorjsrender  :blocks_json="post.short.blocks"></editorjsrender>
                </div>
                <div class="d-flex justify-content-between post_material_mini_bottom">
                  <p><i class="fa fa-calendar-o"></i><small>&nbsp; {{ post.created_at }}</small></p>
                  <p><router-link :to="{name: 'post', params: { id: post.last_id,'alias':post.category_post.alias }}"><i class="fa fa-comment-0"></i>  ({{ post.total_comments_count }})</router-link></p>
                </div>


                <router-link class="btn   " v-if="post.short.blocks.length!=post.content.blocks.length" :to="{name: 'post', params: { id: post.last_id,'alias':post.category_post.alias }}"
                >
                  Читать далее
                </router-link>
              </div>

            </div>


            </div>



    <div class="col-12 col-sm-10 col-md-8 col-lg-8 post_material_mini order-3 order-md-last"v-if="count>current"
          >
      <div class="row d-flex justify-content-center " v-if="count>current">
        <button class="btn" @click="loadCategoryPosts(orderby)">Загрузить еще</button>

      </div>
    </div>












  </div>

  </section>





</template>

<script>
import {eventBus} from "@/main";
import Editorjsrender from "../../models/Editorjsrender.vue";
import Api from "@/models/Api";
import Vue from "vue";
import CategoryCard from "@/components/Custom/CategoryCard.vue";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import UserModel from "../../models/UserModel";

export default {
  name: "Posts",
  data: function () {
    return {
      background_header: "/img/header_bg.jpg",
      user: null,
      islogin: false,
      is_not_have_access:false,
      is_load:false,
      category_access:{write:"0"},
      category:{},
      orderby:'last',
      current: 0,
      count: 0,
      posts: [],
      pinned:[],
      image_url: null,
      search_string:"",
      search_string_need:"",
    }
  },
  mounted() {
    var app = this;
    app.image_url = Vue.config.IMAGE_URL;
    if (app.$store.getters.ISAUTH) {
      var tmpUser = app.$store.getters.USER;

      app.user = tmpUser;
      app.islogin = true;


    }

    if(app.$route.params.orderby){
      app.orderby=app.$route.params.orderby;
    }

    eventBus.$on('user_is_login', user => {
      this.islogin = false;
      if (typeof user === 'object') {
        if (user.api_token) {
          app.user = user;
          app.islogin = true;

        }
      }


    });
    var user=UserModel.get();
    if(user){
      app.loadCategoryPosts();
    }else {
      app.loadCategoryPosts();
    }


  },
  methods: {
    openPost(post_id,alias){
      var app=this;
      app.$router.push({name: 'post', params: { id: post_id,'alias':alias }});
    },
    openProject( ){
      var app=this;

      let routeData = app.$router.resolve({name: 'project',params: {id: app.category.project_id, "rand": Math.random()}});
      window.open(routeData.href, '_self');
    },
    callModalLogin() {
      eventBus.$emit("call_modal_add_project", {type: "login",})
      {

      }
    },

    changeOrderBy(orderby){
      var app=this;
      app.orderby=orderby;
      app.$route.params.orderby=app.orderby;
      app.current=0;
      app.posts=[];
      app.loadCategoryPosts();

    },
    startSearch(){
      var app=this;
      app.is_load=false;
      app.search_string_need=app.search_string;
      app.current=0;
      app.count=0;
      app.posts=[];

      app.loadCategoryPosts();

    },
    loadCategoryPosts(new_orderby=null) {
      var app = this;
      let alias = app.$route.params.alias;
      var orderby=app.orderby;

      if(new_orderby){
        orderby=new_orderby;
      }

      app.orderby=orderby;
      Api.loadCategoryPosts(alias,20, app.current,app.search_string_need, function (data) {
        app.count = data.count;
        app.posts = app.posts.concat(data.posts);

        if(data.category_access){
          app.category_access=data.category_access;
        }else {
          if(data.category.ispublic==1 && app.islogin){
            app.category_access={"write":1};
          }
        }
        app.pinned=data.pinned;
        app.current = app.current + data.posts.length;
        app.category=data.category;
        if(data.category){
          app.is_load=true;
        }
        app.background_header = app.image_url + data.category.background;

        console.log('current is',app.current);
        console.log('count is',app.count);


      },function(err){
        if(err && err.need_auth ){
          app.$router.push({name: 'login',query: { nextUrl: app.$route.fullPath }});

        }else if(err && err.not_have_access){
         app.is_not_have_access=true;
        } else{
          app.$router.push({name:'404'});
        }

       // app.$router.push({name:'404'});

      },orderby);
    },
    callWritePost() {
      var app=this;
      var params = {

        type: "post_new",
        blog_category_default:app.category.last_id,
        blog_category_row:app.category,
        is_project:false,
        modal_title: "Добавить пост",

        json: {
          "blocks": [{
            "type": "header",
            "data": {
              "text": "Название вашего поста",
              "level": 2
            }
          }]
        }
      };
      if(app.category.project_id>0){
        params['is_project']=true;


      }
      eventBus.$emit("call_modal_add_project", params)
      {


      }
    }
  },
  components: {
    'editorjsrender': Editorjsrender,
    'CategoryCard':CategoryCard,
    LoadingBlock,
  }
}
</script>

<style scoped>

</style>